function formatPercentage(str) {
  const percentage = parseFloat(str)
  const percentageInitialFormat = percentage.toFixed(1)
  const percentageFinalFormat = percentageInitialFormat + '%'
  return percentageFinalFormat
}

export default formatPercentage